/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * Milk Bill Reporting System API
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * @summary Health check
 */
export const HealthCheckResponse = zod.object({
  status: zod.string(),
});

/**
 * @summary Get dashboard summary stats
 */
export const GetDashboardSummaryResponse = zod.object({
  totalBillsThisMonth: zod.number(),
  totalMilkQuantity: zod.number(),
  totalAmount: zod.number(),
  totalSocieties: zod.number(),
  totalRoutes: zod.number(),
  pendingBills: zod.number(),
  avgFatPercent: zod.number(),
  avgSnfPercent: zod.number(),
});

/**
 * @summary Get recent bills for dashboard
 */
export const GetRecentBillsResponseItem = zod.object({
  id: zod.number(),
  billNumber: zod.string(),
  billDate: zod.coerce.date(),
  societyName: zod.string(),
  societyCode: zod.string(),
  totalQuantity: zod.number(),
  totalAmount: zod.number(),
  finalPayable: zod.number(),
  status: zod.enum(["draft", "issued", "paid"]),
});
export const GetRecentBillsResponse = zod.array(GetRecentBillsResponseItem);

/**
 * @summary List all milk bills
 */
export const listBillsQueryPageDefault = 1;
export const listBillsQueryLimitDefault = 20;

export const ListBillsQueryParams = zod.object({
  societyId: zod.coerce.number().optional(),
  routeCode: zod.coerce.string().optional(),
  fromDate: zod.date().optional(),
  toDate: zod.date().optional(),
  page: zod.coerce.number().default(listBillsQueryPageDefault),
  limit: zod.coerce.number().default(listBillsQueryLimitDefault),
});

export const ListBillsResponse = zod.object({
  data: zod.array(
    zod.object({
      id: zod.number(),
      billNumber: zod.string(),
      billDate: zod.coerce.date(),
      societyName: zod.string(),
      societyCode: zod.string(),
      totalQuantity: zod.number(),
      totalAmount: zod.number(),
      finalPayable: zod.number(),
      status: zod.enum(["draft", "issued", "paid"]),
    }),
  ),
  total: zod.number(),
  page: zod.number(),
  limit: zod.number(),
});

/**
 * @summary Create a new milk bill
 */
export const CreateBillBody = zod.object({
  billNumber: zod.string(),
  billDate: zod.coerce.date(),
  fromDate: zod.coerce.date(),
  toDate: zod.coerce.date(),
  societyId: zod.number(),
  routeCode: zod.string(),
  shift: zod.enum(["morning", "evening", "both"]),
  bankName: zod.string().optional(),
  bankAccount: zod.string().optional(),
  bankIfsc: zod.string().optional(),
  rateFormula: zod.string().optional(),
  leadLoadAmount: zod.number().optional(),
  status: zod.enum(["draft", "issued", "paid"]).optional(),
});

/**
 * @summary Get a single milk bill by ID
 */
export const GetBillParams = zod.object({
  id: zod.coerce.number(),
});

export const GetBillResponse = zod
  .object({
    id: zod.number(),
    billNumber: zod.string(),
    billDate: zod.coerce.date(),
    fromDate: zod.coerce.date(),
    toDate: zod.coerce.date(),
    societyId: zod.number(),
    societyName: zod.string(),
    societyCode: zod.string(),
    routeCode: zod.string(),
    shift: zod.enum(["morning", "evening", "both"]),
    bankName: zod.string().optional(),
    bankAccount: zod.string().optional(),
    bankIfsc: zod.string().optional(),
    rateFormula: zod.string().optional(),
    totalQuantity: zod.number(),
    totalAmount: zod.number(),
    totalDeductions: zod.number(),
    leadLoadAmount: zod.number(),
    finalPayable: zod.number(),
    status: zod.enum(["draft", "issued", "paid"]),
    createdAt: zod.coerce.date(),
  })
  .and(
    zod.object({
      entries: zod.array(
        zod.object({
          id: zod.number(),
          billId: zod.number(),
          entryDate: zod.coerce.date(),
          shift: zod.enum(["morning", "evening"]),
          quantity: zod.number(),
          fatPercent: zod.number(),
          snfPercent: zod.number(),
          rate: zod.number(),
          amount: zod.number(),
        }),
      ),
      deductions: zod.array(
        zod.object({
          id: zod.number(),
          billId: zod.number(),
          category: zod.enum([
            "financial",
            "dcs_training",
            "share_account",
            "test_chem",
            "cattle_feed",
            "other",
          ]),
          label: zod.string(),
          amount: zod.number(),
        }),
      ),
      priceDifference: zod.number().optional(),
    }),
  );

/**
 * @summary Update a milk bill
 */
export const UpdateBillParams = zod.object({
  id: zod.coerce.number(),
});

export const UpdateBillBody = zod.object({
  billNumber: zod.string(),
  billDate: zod.coerce.date(),
  fromDate: zod.coerce.date(),
  toDate: zod.coerce.date(),
  societyId: zod.number(),
  routeCode: zod.string(),
  shift: zod.enum(["morning", "evening", "both"]),
  bankName: zod.string().optional(),
  bankAccount: zod.string().optional(),
  bankIfsc: zod.string().optional(),
  rateFormula: zod.string().optional(),
  leadLoadAmount: zod.number().optional(),
  status: zod.enum(["draft", "issued", "paid"]).optional(),
});

export const UpdateBillResponse = zod.object({
  id: zod.number(),
  billNumber: zod.string(),
  billDate: zod.coerce.date(),
  fromDate: zod.coerce.date(),
  toDate: zod.coerce.date(),
  societyId: zod.number(),
  societyName: zod.string(),
  societyCode: zod.string(),
  routeCode: zod.string(),
  shift: zod.enum(["morning", "evening", "both"]),
  bankName: zod.string().optional(),
  bankAccount: zod.string().optional(),
  bankIfsc: zod.string().optional(),
  rateFormula: zod.string().optional(),
  totalQuantity: zod.number(),
  totalAmount: zod.number(),
  totalDeductions: zod.number(),
  leadLoadAmount: zod.number(),
  finalPayable: zod.number(),
  status: zod.enum(["draft", "issued", "paid"]),
  createdAt: zod.coerce.date(),
});

/**
 * @summary Delete a milk bill
 */
export const DeleteBillParams = zod.object({
  id: zod.coerce.number(),
});

/**
 * @summary Get milk entries for a bill
 */
export const GetBillEntriesParams = zod.object({
  id: zod.coerce.number(),
});

export const GetBillEntriesResponseItem = zod.object({
  id: zod.number(),
  billId: zod.number(),
  entryDate: zod.coerce.date(),
  shift: zod.enum(["morning", "evening"]),
  quantity: zod.number(),
  fatPercent: zod.number(),
  snfPercent: zod.number(),
  rate: zod.number(),
  amount: zod.number(),
});
export const GetBillEntriesResponse = zod.array(GetBillEntriesResponseItem);

/**
 * @summary Get deductions for a bill
 */
export const GetBillDeductionsParams = zod.object({
  id: zod.coerce.number(),
});

export const GetBillDeductionsResponseItem = zod.object({
  id: zod.number(),
  billId: zod.number(),
  category: zod.enum([
    "financial",
    "dcs_training",
    "share_account",
    "test_chem",
    "cattle_feed",
    "other",
  ]),
  label: zod.string(),
  amount: zod.number(),
});
export const GetBillDeductionsResponse = zod.array(
  GetBillDeductionsResponseItem,
);

/**
 * @summary List all societies
 */
export const ListSocietiesResponseItem = zod.object({
  id: zod.number(),
  name: zod.string(),
  code: zod.string(),
  routeCode: zod.string(),
  bankName: zod.string().optional(),
  bankAccount: zod.string().optional(),
  bankIfsc: zod.string().optional(),
  contactPerson: zod.string().optional(),
  phone: zod.string().optional(),
});
export const ListSocietiesResponse = zod.array(ListSocietiesResponseItem);

/**
 * @summary Create a society
 */
export const CreateSocietyBody = zod.object({
  name: zod.string(),
  code: zod.string(),
  routeCode: zod.string(),
  bankName: zod.string().optional(),
  bankAccount: zod.string().optional(),
  bankIfsc: zod.string().optional(),
  contactPerson: zod.string().optional(),
  phone: zod.string().optional(),
});

/**
 * @summary List all routes
 */
export const ListRoutesResponseItem = zod.object({
  id: zod.number(),
  code: zod.string(),
  name: zod.string(),
  description: zod.string().optional(),
});
export const ListRoutesResponse = zod.array(ListRoutesResponseItem);

/**
 * @summary List all bank advice records
 */
export const ListBankAdviceQueryParams = zod.object({
  fromDate: zod.date().optional(),
  toDate: zod.date().optional(),
});

export const ListBankAdviceResponseItem = zod.object({
  id: zod.number(),
  billId: zod.number(),
  billNumber: zod.string(),
  societyName: zod.string(),
  bankName: zod.string().optional(),
  bankAccount: zod.string().optional(),
  bankIfsc: zod.string().optional(),
  amount: zod.number(),
  adviceDate: zod.coerce.date(),
  status: zod.enum(["pending", "processed", "failed"]),
});
export const ListBankAdviceResponse = zod.array(ListBankAdviceResponseItem);

/**
 * @summary Get monthly bill summary
 */
export const GetMonthlySummaryQueryParams = zod.object({
  year: zod.coerce.number(),
  month: zod.coerce.number().optional(),
});

export const GetMonthlySummaryResponseItem = zod.object({
  month: zod.number(),
  year: zod.number(),
  totalBills: zod.number(),
  totalQuantity: zod.number(),
  totalAmount: zod.number(),
  totalDeductions: zod.number(),
  totalPayable: zod.number(),
  avgFat: zod.number(),
  avgSnf: zod.number(),
});
export const GetMonthlySummaryResponse = zod.array(
  GetMonthlySummaryResponseItem,
);

/**
 * @summary Get yearly summary
 */
export const GetYearlySummaryQueryParams = zod.object({
  year: zod.coerce.number(),
});

export const GetYearlySummaryResponse = zod.object({
  year: zod.number(),
  totalBills: zod.number(),
  totalQuantity: zod.number(),
  totalAmount: zod.number(),
  totalPayable: zod.number(),
  monthlyBreakdown: zod.array(
    zod.object({
      month: zod.number(),
      year: zod.number(),
      totalBills: zod.number(),
      totalQuantity: zod.number(),
      totalAmount: zod.number(),
      totalDeductions: zod.number(),
      totalPayable: zod.number(),
      avgFat: zod.number(),
      avgSnf: zod.number(),
    }),
  ),
});

/**
 * @summary List all purchases
 */
export const ListPurchasesResponseItem = zod.object({
  id: zod.number(),
  societyId: zod.number(),
  societyName: zod.string(),
  purchaseDate: zod.coerce.date(),
  quantity: zod.number(),
  fatPercent: zod.number(),
  snfPercent: zod.number(),
  rate: zod.number(),
  amount: zod.number(),
  shift: zod.enum(["morning", "evening"]),
});
export const ListPurchasesResponse = zod.array(ListPurchasesResponseItem);

/**
 * @summary Create a purchase record
 */
export const CreatePurchaseBody = zod.object({
  societyId: zod.number(),
  purchaseDate: zod.coerce.date(),
  quantity: zod.number(),
  fatPercent: zod.number(),
  snfPercent: zod.number(),
  rate: zod.number(),
  shift: zod.enum(["morning", "evening"]),
});

/**
 * @summary List all targets
 */
export const ListTargetsResponseItem = zod.object({
  id: zod.number(),
  societyId: zod.number(),
  societyName: zod.string(),
  period: zod.string(),
  targetQuantity: zod.number(),
  achievedQuantity: zod.number(),
  targetAmount: zod.number(),
  achievedAmount: zod.number(),
  percentAchieved: zod.number(),
});
export const ListTargetsResponse = zod.array(ListTargetsResponseItem);

/**
 * @summary Create a target
 */
export const CreateTargetBody = zod.object({
  societyId: zod.number(),
  period: zod.string(),
  targetQuantity: zod.number(),
  targetAmount: zod.number(),
});

/**
 * @summary List DCS monitoring records
 */
export const ListDcsMonitoringResponseItem = zod.object({
  id: zod.number(),
  societyId: zod.number(),
  societyName: zod.string(),
  testDate: zod.coerce.date(),
  fatReading: zod.number(),
  snfReading: zod.number(),
  status: zod.enum(["pass", "fail", "pending"]),
  remarks: zod.string().optional(),
});
export const ListDcsMonitoringResponse = zod.array(
  ListDcsMonitoringResponseItem,
);
